import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { CgSortAz, CgSortZa } from "react-icons/cg";
import { IoMdPlay } from "react-icons/io";
import PillBox from "../../assets/icons/medicineList/PillBox";
import { FaEye, FaImage } from "react-icons/fa6";
import ModalStructure from "../ModalStructure";
import CustomCellModal from "./CustomCellModal";
import ProductForm from "./ProductForm";
import Refresh from "../../assets/icons/Refresh";
import { deleteProduct } from "../../services/products";
import { TiArrowSortedDown, TiArrowSortedUp } from "react-icons/ti";
import { IS_LOCAL_ENV } from "../../App";
import Notification from "../ui-elements/Notification";
import SpecsModal from "./modals/SpecsModal";
import { MdEdit } from "react-icons/md";

const colors = {
  FFFFFF: "Blanco",
  E6E6FA: "Lila",
  FFC0CB: "Rosa",
  FF00FF: "Fucsia",
  FFFF00: "Amarillo",
  FFA500: "Naranja",
  800080: "Púrpura",
  "4B0082": "Morado",
  FF0000: "Rojo",
  "008000": "Verde",
  "0000FF": "Azul",
  "8B4513": "Marrón",
  "000000": "Negro",
};

const translatedStatus = {
  available: "Disponible",
  unavailable: "No disponible",
  reserved: "Reservado",
  sold: "Vendido",
  other: "Otro",
};

const translatedType = {
  orchid: "Orquídea",
  medicine: "Medicina",
  substratum: "Sustrato",
  succulent: "Suculenta",
  other: "Otros",
};

const bodyCols = [
  "code", // Código de producto
  "sku", // sku
  "name",
  "subClass",
  "status",
  "mainImage",
  "images",
  "entryDate", // Precio de compra
  "providerName",
  "providerRuc", // Imagen principal (relación con "images")
  "specs", //jutar mainsSpecs con otherSpecs
  //"mainSpecs",
  //"otherSpecs",
  "purchasePrice",
  "salePrice",
  "inOffer",
  "offerDiscount",
  "offerEndDate",
  "postSaleWait",
  "",
];

const header = [
  "Código",
  "SKU",
  "Nombre individual",
  "SubClase",
  "Estado",
  "Imagen principal",
  "Otras imágenes",
  "Fecha de ingreso",
  "Nombre proveedor",
  "RUC",
  "Especificaciones",
  "Precio de compra",
  "Precio de venta",
  "Aplica oferta",
  "Descuento %",
  "Fecha fin oferta",
  "Tiempo de espera después de compra",
  "",
];

const translatedColumn = (column) => {
  return column == "mainImage"
    ? "Imagen principal"
    : "images"
    ? "Otras imágenes"
    : "videos"
    ? "Videos"
    : "";
};

const InventoryTable = ({
  _data,
  updateSortedProp,
  subClasses,
  uploadParentSC,
}) => {
  const [data, setData] = useState(_data);
  const [sortedBy, setSortedBy] = useState(-1); //por que atributo se ordena la data
  const [sortType, setSortType] = useState("default"); //o reversed
  const [sortedColumn, setSortedColumn] = useState(-1);
  const [sortChange, setSortChange] = useState(0);
  const [updatePoductIndex, setUpdatePoductIndex] = useState(null);
  const [selectedUpdateIndex, setSelectedUpdateIndex] = useState(null);
  const [selectedDeleteIndex, setSelectedDeleteIndex] = useState(null);
  const [updatingProduct, setUpdatingProduct] = useState(false);
  const [deletingProduct, setDeletingProduct] = useState(false);
  const [selectedSpecsIndex, setSelectedSpecsIndex] = useState(null);

  useEffect(() => {
    setData(_data);
  }, [_data]);

  IS_LOCAL_ENV && console.log("data", data);

  const [cellModalData, setCellModalData] = useState({});
  const [showCellModal, setShowCellModal] = useState(false);

  //==========================sort funcs================================
  // const toggleSortedType = () => {
  //   let str = bodyCols[sortedColumn];
  //   if (sortType === "default" || sortType === "sorted") {
  //     setSortType("reversed");
  //     if(["offer", "class", "provider"].some(subs=>bodyCols[sortedColumn].includes(subs))){
  //       //para evaluar si es un campo perteneciente a algun field agrupado
  //       if(str.includes("provider")) str = `provider.${str}`;
  //       else if(str.includes("class")) str = `classification.${str}`;
  //       else if(str.includes("offer")) str = `offer.${str}`;
  //     }
  //     updateSortedProp(`-${str}`);
  //   } else {
  //     setSortType("sorted");
  //     updateSortedProp(str);
  //   }
  // };

  const toggleSortedType = () => {
    let str = bodyCols[sortedColumn];
    const prefixes = {
      //provider: "provider",
      //class: "classification",
      //offer: "offer",
    };

    // Caso 1: Ya tiene prefijo negativo "-provider.providerRuc"
    if (str.startsWith("-")) {
      // Simplemente eliminar el "-"
      setSortType("sorted");
      str = str.substring(1);
    }
    // Caso 2: Tiene prefijo pero no negativo "provider.providerRuc"
    else if (
      Object.values(prefixes).some((prefix) => str.startsWith(`${prefix}.`))
    ) {
      // Agregar "-"
      setSortType("reversed");
      str = `-${str}`;
    }
    // Caso 3: No tiene prefijo
    else {
      // Agregar prefijo si es necesario
      Object.keys(prefixes).forEach((prefix) => {
        if (str.includes(prefix)) {
          str = `${prefixes[prefix]}.${str}`;
        }
      });

      // Cambiar tipo de ordenamiento
      if (sortType === "default" || sortType === "sorted") {
        setSortType("reversed");
        str = `-${str}`;
      } else {
        setSortType("sorted");
      }
    }

    updateSortedProp(str);
  };

  const onClickSortBy = (i) => {
    if (i === sortedColumn) {
      // Si se hace clic en la misma columna, cambiar el tipo de ordenamiento
      toggleSortedType();
    } else {
      // Si se hace clic en una columna diferente, establecer la nueva columna y ordenar
      setSortedColumn(i);

      let str = bodyCols[i]; // Obtener el campo seleccionado
      const prefixes = {
        //provider: "provider",
        //class: "classification",
        //offer: "offer",
      };

      // Validar si el campo ya contiene un prefijo
      const hasPrefix = Object.values(prefixes).some((prefix) =>
        str.startsWith(`${prefix}.`)
      );

      if (!hasPrefix) {
        // Agregar prefijo si pertenece a un grupo
        Object.keys(prefixes).forEach((prefix) => {
          if (str.includes(prefix)) {
            str = `${prefixes[prefix]}.${str}`;
          }
        });
      }

      updateSortedProp(str);
      setSortType("sorted");
    }
  };

  //====================================================================

  const handleClickCell = (index, column) => {
    let obj = data?.[index]?.[column] || null;
    if (!obj) return;
    obj = { field: column, data: obj, title: translatedColumn(column) };
    setCellModalData(obj);
    setShowCellModal(true);
  };

  const loadToParent = (newObj, prevId) => {
    let temp = [...data];
    if (!prevId) {
      temp.push(newObj);
      setData(temp);
    } else {
      const prevIndex = temp.findIndex((obj) => obj.id == prevId);
      if (prevIndex == -1) return;
      temp[prevIndex] = newObj;
      setData(temp);
    }
  };

  const offerOngoing = (endDate) => {
    let fd = new Date(endDate);
    return fd > new Date(Date.now());
  };

  const onClickDeleteProduct = (index) => {
    const deleteData = async (index) => {
      try {
        setDeletingProduct(true);
        await deleteProduct(data[index].id);
        Notification({
          title: "Operación completada",
          text: "Producto eliminado satiscactorimente",
          type: "Success",
        });
        setData(data.filter((product, i) => i !== index));
        setDeletingProduct(false);
        setSelectedDeleteIndex(null);
      } catch (err) {
        setDeletingProduct(false);
        IS_LOCAL_ENV && console.error(err);
        setSelectedDeleteIndex(null);
        Notification({
          title: "Error",
          text: "Algo salió mal... ",
          type: "Error",
        });
      }
    };
    deleteData(index);
  };

  const uploadSpecs = (specs) => {
    let temp = [...data];
    temp[selectedSpecsIndex].specs = specs;
    setData(temp);
  };

  return (
    <>
      <Table>
        <TableHead
          sx={{ display: "table-header-group", width: "100%" }}
          className="bg-dark-green font-white font-bold"
        >
          <TableRow sx={{ border: 0 }}>
            {header.map((columnTitle, i) => {
              return (
                <TableCell key={i} align={`${i > 0 ? "right" : ""}`}>
                  <div className="justify-between items-center flex flex-row">
                    <span className="font-poppins font-bold text-white text-nowrap">
                      {columnTitle}
                    </span>
                    {![
                      "Imagen Principal",
                      "Otras imágenes",
                      "Otras especificaciones",
                      "Especificaciones principales",
                      "",
                    ].includes(columnTitle) && (
                      <span
                        className={`hover:bg-accent-green hover:opacity-90 p-1 m-1 rounded-[50%] transition-colors ${
                          sortedColumn == i
                            ? "bg-white text-dark-green"
                            : "text-white"
                        }`}
                        onClick={() => onClickSortBy(i)}
                      >
                        {sortedColumn == i && sortType == "reversed" ? (
                          <TiArrowSortedDown className=" w-[25px] h-[25px]" />
                        ) : (
                          <TiArrowSortedUp className=" w-[25px] h-[25px]" />
                        )}
                      </span>
                    )}
                  </div>
                </TableCell>
              );
            })}
          </TableRow>
        </TableHead>
        <TableBody>
          {data.map((row, i) => {
            return (
              <TableRow
                key={i}
                className={`${
                  i % 2 == 0 ? "bg-white" : "bg-light-green"
                }  border-y-[2px] border-accent-green`}
              >
                {bodyCols.map((col, j) => {
                  return (
                    <TableCell key={j}>
                      <div
                        className={`flex flex-row ${
                          j == 0 ? "justify-start" : "justify-end"
                        } w-full font-poppins text-dark-green px-2`}
                      >
                        {col == "images" || col == "videos" ? (
                          <span
                            className={`flex flex-row hover:bg-simple-gray px-2 py-1 rounded-md gap-x-1 text-nowrap items-center text-dark-green hover:cursor-pointer`}
                            onClick={() => handleClickCell(i, col)}
                          >
                            {col == "images" && (
                              <>
                                <FaImage className=" mr-1 w-[20px] h-[20px] text-accent-green" />{" "}
                                Ver galería
                              </>
                            )}
                            {col == "videos" && (
                              <>
                                <IoMdPlay className=" text-accent-green mr-1 w-[20px] h-[20px]" />{" "}
                                Ver videos
                              </>
                            )}
                          </span>
                        ) : col == "mainImage" ? (
                          <div
                            className={`h-[50px] w-auto overflow-hidden relative`}
                          >
                            <img
                              src={
                                row[col]
                                  ? `${process.env.REACT_APP_SERVER}${row[col].url}`
                                  : ""
                              }
                              className="w-[60px] h-full object-cover object-center rounded-xl"
                            />
                          </div>
                        ) : col === "offerEndDate" ? (
                          row.offerEndDate ? (
                            new Date(row.offerEndDate).toLocaleDateString()
                          ) : (
                            "--"
                          )
                        ) : col === "status" ? (
                          translatedStatus[row.status]
                        ) : col === "specs" ? (
                          <button
                            className={`flex flex-row hover:bg-simple-gray px-2 py-1 rounded-md gap-x-1 text-nowrap items-center text-dark-green hover:cursor-pointer`}
                            onClick={() => setSelectedSpecsIndex(i)}
                          >
                            <FaEye className="text-accent-green text-lg" />
                            Ver especificaciones
                          </button>
                        ) : col === "offerDiscount" ? (
                          row.offerDiscount ? (
                            <b>
                              {`${row.offerDiscount}% (${(
                                parseFloat(row.salePrice) -
                                (parseFloat(row.offerDiscount) / 100) *
                                  parseFloat(row.salePrice)
                              ).toFixed(2)})`}
                            </b>
                          ) : (
                            "--"
                          )
                        ) : col == "entryDate" ? (
                          <span>{new Date(row[col]).toLocaleDateString()}</span>
                        ) : col == "" ? (
                          <div className="flex flex-row items-center gap-x-2">
                            <button
                              className={` w-fit text-sm  rounded-full py-2 px-4 text-white  transition-all duration-100 font-bold font-poppins ${
                                updatingProduct
                                  ? "bg-default-gray cursor-not-allowed"
                                  : "bg-dark-green hover:bg-accent-green"
                              } `}
                              onClick={(e) => {
                                setSelectedUpdateIndex(i);
                              }}
                              disabled={updatingProduct}
                            >
                              <div className="flex flex-row items-center gap-x-1 px-4">
                                <span className="text-nowrap">Editar</span>
                                <MdEdit />
                              </div>
                            </button>

                            {/* <button
                              className={` w-fit text-sm  rounded-full py-2 px-4 text-white  transition-all duration-100 font-bold font-poppins ${
                                deletingProduct
                                  ? "bg-default-gray cursor-not-allowed"
                                  : "bg-red-600 hover:bg-red-400"
                              } `}
                              //onClick={(e) => {
                              //  setSelectedDeleteIndex(i);
                              // }}
                              //disabled={deletingProduct}
                            >
                              <div className="flex flex-row items-center gap-x-1 px-4">
                                <span className="text-nowrap">Eliminar</span>
                              </div>
                            </button> */}
                          </div>
                        ) : (
                          <span className="flex flex-row justify-end text-nowrap">
                            {col == "subClass"
                              ? row.subClass.name
                              : col == "inOffer"
                              ? row.inOffer
                                ? "Sí"
                                : "No"
                              : row[col]}
                            {col == "age" && " meses"}
                            {col == "postSaleWait" && " días"}
                          </span>
                        )}
                      </div>
                    </TableCell>
                  );
                })}
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
      {/* Modales: */}
      {selectedDeleteIndex !== null && (
        <ModalStructure
          handleCloseModal={() => setSelectedDeleteIndex(null)}
          customMaxW={"max-w-[400px]"}
        >
          <div className="font-poppins flex flex-col items-center">
            <h3 className="text-lg font-bold px-4">
              ¿Estás seguro de que quieres eliminar este producto?
            </h3>
            <button
              className={` w-fit  text-base m-4 mr-0 rounded-full py-2 px-4 text-white  transition-all duration-100 font-bold font-poppins ${
                deletingProduct
                  ? "bg-default-gray cursor-not-allowed"
                  : "bg-red-600 hover:bg-red-400"
              } `}
              onClick={(e) => {
                onClickDeleteProduct(selectedDeleteIndex);
              }}
              disabled={deletingProduct}
            >
              <div className="flex flex-row items-center gap-x-1 px-4">
                <span className="text-nowrap">Eliminar</span>
              </div>
            </button>
          </div>
        </ModalStructure>
      )}
      {showCellModal && (
        <ModalStructure
          handleCloseModal={() => setShowCellModal(false)}
          customMaxW={
            cellModalData.field === "supplies" ? "max-w-[250px]" : null
          }
        >
          <CustomCellModal props={cellModalData} />
        </ModalStructure>
      )}
      {selectedUpdateIndex !== null && (
        <ModalStructure
          handleCloseModal={() => setSelectedUpdateIndex(null)}
          customMaxW={"max-w-[1280px]"}
        >
          <ProductForm
            prevData={data[selectedUpdateIndex]}
            handleClose={() => setSelectedUpdateIndex(null)}
            loadToParent={loadToParent}
            subClasses={subClasses}
            uploadParentSC={uploadParentSC}
          />
        </ModalStructure>
      )}
      {/*Modal de ver especificaciones de producto */}
      {selectedSpecsIndex !== null && (
        <SpecsModal
          handleCloseModal={() => setSelectedSpecsIndex(null)}
          _data={{
            mainSpecs: data[selectedSpecsIndex].mainSpecs,
            otherSpecs: data[selectedSpecsIndex].otherSpecs,
          }}
          editable={false}
          uploadParent={(newSpecs) => uploadSpecs(newSpecs)}
        />
      )}
    </>
  );
};

export default InventoryTable;
